import React from "react";
import Productpage from "../../productpage2";
import SEO from "../../seo";
export default function OutlastPage({ location }) {
  const data = {
    galleryImages: [
      "https://eclipsemattress.in/assets/images/products/outlast/Outlast-n-04.png",
      "https://eclipsemattress.in/assets/images/products/outlast/Outlast-n-01.png",
      "https://eclipsemattress.in/assets/images/products/outlast/Outlast-n-02.png",
      "https://eclipsemattress.in/assets/images/products/outlast/Outlast-n-03.png",
    ],
    productName: "Outlast",
    productLogo:
      "https://eclipsemattress.in/assets/images/products/outlast/outlast-logo.png",
    descriptionTitle: "",
    descriptionText:
      "As the name suggests, Outlast is designed to fulfill any of your sleep desires in terms of comfort and luxury. It derives its name from the Outlast fibre used in its manufacturing. Outlast fibre was first designed by NASA for their moon landing programme. It is decked with the excellent qualities of absorbing, storing and releasing heat in the form of latent heat to maintain overall body temperature.",
    category: { title: "Harmony Collection", link: "/harmony-collection/" },
    points: [
      "Specialised Outlast fibre developed by NASA for spacesuits",
      "Absorbs, stores & releases latent heat for thermally optimal sleep",
      "Odour-free, environment friendly & highly breathable",
      "Pressure-relieving Eclipse Visco Elastic Memory Foam",
      "Weight distribution for optimum support",
      "Luxurious HR Foam base",
    ],

    featuresText: [
      "Eclipse Smart Outlast Fiber",
      "Eclipse Memory Foam",
      "Eclipse HR Foam",
    ],
    featuresImage:
      "https://eclipsemattress.in/assets/images/products/outlast/Outlast-n-06.png",
    warrantyIcons: [
      "https://eclipsemattress.in/assets/images/products/outlast/Outlast-n-07.png",
      "https://eclipsemattress.in/assets/images/products/outlast/Outlast-n-08.png",
      "https://eclipsemattress.in/assets/images/products/outlast/Outlast-n-09.png",
      "https://eclipsemattress.in/assets/images/products/outlast/Outlast-n-10.png",
      "https://eclipsemattress.in/assets/images/products/outlast/Outlast-n-11.png",
      "https://eclipsemattress.in/assets/images/products/outlast/Outlast-n-12.png",
    ],

    warrantyImage:
      "https://eclipsemattress.in/assets/images/products/outlast/Outlast-n-05.png",
    price: "₹31,799 - ₹1,12,099",
    brochureLink:
      "https://eclipsemattress.in/assets/pdfs/Patent-&-Luxury-Catalogue.pdf",

    relatedProducts: [
      {
        title: "Harmony Edge",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/harmony-edge.jpg",
        link: "/harmony-collection/harmony-edge/",
      },
      {
        title: "Romance",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/romance.jpg",
        link: "/patent-series-mattress/romance/",
      },
      {
        title: "Tiara Cool",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/tiara-cool.jpg",
        link: "/patent-series-mattress/tiara-cool/",
      },
    ],
  };

  return (
    <div>
      <SEO
        title="Outlast Memory Foam Mattress | Eclipse International"
        description="Buy Eclipse outlast memory foam mattress with 5 years warranty that is free of odors, environmental friendly and breathable that is luxurious High Resilience Foam at base"
      />
      <Productpage location={location} product={data} />
    </div>
  );
}
